/** @file The grip axis of a socket in its parent bone's space: base a and tip b (socket.setPoints). */
import type { Id, SocketDoc } from '@pose2d/format/types';
import type { Translate } from '@pose2d/i18n/types';
import { NumberField } from '../../ui-kit/NumberField';
import type { RunCommands } from '../rigKit/rigView';

/** Props of SocketPoints. */
export interface SocketPointsProps {
  t: Translate;
  run: RunCommands;
  id: Id;
  socket: SocketDoc;
}

/** Each field sends only its own point; a == b is refused by validateDoc and shown as the command's error. */
export function SocketPoints({ t, run, id, socket }: SocketPointsProps) {
  const [ax, ay] = socket.a;
  const [bx, by] = socket.b;
  const send = (point: 'a' | 'b', value: [number, number]): void => { run([{ name: 'socket.setPoints', input: { target: id, [point]: value } }]); };
  return (
    <fieldset className="rig-fields">
      <legend>{socket.name}</legend>
      <NumberField label={t('panels.sockets.ax')} value={ax} step={1} precision={2} onCommit={(v) => { send('a', [v, ay]); }} />
      <NumberField label={t('panels.sockets.ay')} value={ay} step={1} precision={2} onCommit={(v) => { send('a', [ax, v]); }} />
      <NumberField label={t('panels.sockets.bx')} value={bx} step={1} precision={2} onCommit={(v) => { send('b', [v, by]); }} />
      <NumberField label={t('panels.sockets.by')} value={by} step={1} precision={2} onCommit={(v) => { send('b', [bx, v]); }} />
    </fieldset>
  );
}
